import ServiceOfferingsIcon from '../components/assets/header/ServiceOfferingsIcon.svg'
import HowItWorksIcon from '../components/assets/header/HowItWorksIcon.svg'
import ReferralRatesIcon from '../components/assets/header/ReferralRatesIcon.svg'
import Grow from '../components/assets/header/Grow.svg'
import GetStarted from '../components/assets/header/GetStarted.svg'

export const HeaderMegaMenuOptions = [
  {
    headerMainTitle: 'get-started',
    img: <GetStarted />,
    menuSelection: [
      {
        name: 'How it works',
        description: 'A straightforward journey from application to launch',
        icon: <HowItWorksIcon />,
        href: '/how-it-works',
      },
      {
        name: 'Referral rates',
        description: 'Competitive rates for a curated marketplace',
        icon: <ReferralRatesIcon />,
        href: '/referral-rates',
      },
    ],
  },
  {
    headerMainTitle: 'grow',
    img: <Grow />,
    menuSelection: [
      {
        name: 'Service offerings',
        description: 'Platforms to help you scale',
        icon: <ServiceOfferingsIcon />,
        href: '/service-offerings',
      },
    ],
  },
]
